<template>
    <div class="help">
        <public1></public1>
        <div class="help-content right-content">
            <div class="perheader">
                <perheader></perheader>
            </div>
            <div class="table-content">



            </div>



        </div>
    </div>
</template>

<script>
    import public1 from '@/views/public1.vue'
    import perheader from '@/components/perheader.vue'
    export default {
        name: "help",
        components: {
            public1,
            perheader,
        },
    }
</script>

<style scoped>
    .help{
        height:100%;
    }
    .help-content{
        margin:0.4rem 0.5rem;
    }
    .table-content{
        width:90%;
        height:50%;
        border:1px solid #cecece;
        margin-top:0.5rem;
        margin-left:2%;
        display: flex;
        font-size:22px;
    }

</style>